import Vue from "vue";
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);
import { createNamespacedHelpers } from "vuex";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "pWalletMenu",
  computed: {
    ...walletVuex.mapState(["isMobile", "address", "netId"])
  },
  data() {
    const menu = [{
      label: this.$lang("Copy Address"),
      value: "copy",
      icon: "copy"
    }, {
      label: this.$lang("Explorer"),
      value: "explorer",
      icon: "explorer"
    }, {
      label: this.$lang("Switch network"),
      value: "switchnetwork",
      icon: "icon-conversion"
    }, {
      label: this.$lang("Disconnect"),
      value: "disconnect",
      icon: "disconnect"
    }];
    return {
      menu
    };
  },
  methods: {
    ...walletVuex.mapActions(["disConnect"]),
    async onSkip(item) {
      switch (item.value) {
        case "copy":
          this.$copyText(this.address).then(this.$toasted.success("Copyed!"));
          break;
        case "disconnect":
          this.$parent.pWalletMenuShow = false;
          await this.web3Wallet.disConnect();
          this.$toasted.clear();
          const disconnectToast = this.$toasted.info("Disconnected!", {
            duration: 1800
          });
          // Some wallet providers keep the event loop busy while disconnecting.
          // Explicitly dismiss as a fallback so the notice never stays pinned.
          window.setTimeout(() => disconnectToast && disconnectToast.goAway(0), 2000);
          break;
        case "switchnetwork":
          this.web3Wallet.modal.open({
            view: "Networks"
          });
          this.$parent.pWalletMenuShow = false;
          break;
        case "explorer":
          open(`${this.web3Wallet.explorer.url}/address/${this.address}`, "target");
          break;
      }
    }
  }
};